
const allowedVeeRules = [
  'required',
  'confirmed',
  'email',
  'numeric',
  'url',
  'phone',
  'coupon',
]

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      honeypot: null,
      serverValidationErrors: null,
      fields: this.data.fields.map((f) => {
        const field = f.field

        field.handle = f.handle

        field.rules = field.validate ? field.validate.join('|') : null

        if (field.type === 'checkboxes' && field.options) {
          field.value = []
        } else {
          field.value = field.default
            ? ['false', 'true'].includes(field.default)
              ? field.default === 'true'
              : field.default
            : null
        }

        if (field.options) {
          field.selectOptions = Object.entries(field.options).map(
            ([key, label]) => ({
              key,
              label,
            })
          )
        }

        if (field.rules?.split('|').includes('required')) {
          field.required = true
        } else {
          field.required = false
        }

        switch (field.width) {
          case 25:
            field.colspan = 'md:col-span-3'
            break
          case 33:
            field.colspan = 'md:col-span-4'
            break
          case 50:
            field.colspan = 'md:col-span-6'
            break
          case 66:
            field.colspan = 'md:col-span-8'
            break
          case 75:
            field.colspan = 'md:col-span-9'
            break
          default:
            field.colspan = 'md:col-span-12'
        }

        return field
      }),
    }
  },

  methods: {
    validVeeRules(rules) {
      if (!rules) {
        return rules
      }

      return rules
        .split('|')
        .filter((rule) => allowedVeeRules.includes(rule.split(':')[0]))
        .join('|')
    },

    async onSubmit() {
      if (this.loading) {
        return
      }

      this.serverValidationErrors = null
      this.loading = true

      const form = this.fields
        .filter((field) => {
          return this.isVisibleByCondition(field)
        })
        .reduce(
          (form, field) => {
            let value = field.value

            if (field.value?.label) {
              value = field.value.label // checkbox value
            }

            return { ...form, [field.handle]: value }
          },
          { honeypot: this.honeypot }
        )

      try {
        await this.$axios.$post(`/cms/forms/${this.data.id}`, form, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })

        this.fields.map((f) => {
          if (f.type === 'checkboxes' && f.options) {
            f.value = []
          } else {
            f.value = null
          }
          return f
        })

        this.$refs.form.reset()

        this.$toast.success(this.$t('form-success'))
      } catch ({ response }) {
        if (response.status === 400 || response.status === 422) {
          this.$refs.form.setErrors(response.data.error)
          this.serverValidationErrors = response.data.error
        } else {
          this.$toast.error(this.$t('form-error'))
        }
      } finally {
        this.loading = false
      }
    },

    isVisibleByCondition(field) {
      if (!field.if && !field.if_any && !field.unless && !field.unless_any) {
        return true
      }

      if (field.if) {
        const conditions = field.if
        return Object.keys(conditions).every((field) =>
          this.testCondition(field, conditions[field])
        )
      } else if (field.if_any) {
        const conditions = field.if_any
        return Object.keys(conditions).some((field) =>
          this.testCondition(field, conditions[field])
        )
      } else if (field.unless) {
        const conditions = field.unless
        return !Object.keys(conditions).every((field) =>
          this.testCondition(field, conditions[field])
        )
      } else if (field.unless_any) {
        const conditions = field.unless_any
        return !Object.keys(conditions).some((field) =>
          this.testCondition(field, conditions[field])
        )
      }

      return false
    },

    testCondition(field, condition) {
      const testField = this.fields.find((f) => f.handle === field)
      if (!testField) {
        console.error(`field ${field} not found, checking condition failed!`)

        return false
      }

      const [, operator, testForValue] = condition.match(/^([^\s]+) (.+)/)

      switch (operator) {
        case 'equals':
        case '===':
          return testField?.value?.toString() === testForValue
        case 'not':
        case '!==':
          return testField?.value?.toString() !== testForValue
        case 'contains':
          return testField?.value?.toString().includes(testForValue)
        case 'contains_any':
          return testForValue
            ?.split(',')
            .some((v) => testField?.value?.toString().includes(v))
        case '>':
          return testField?.value > testForValue
        case '>=':
          return testField?.value >= testForValue
        case '<':
          return testField?.value < testForValue
        case '<=':
          return testField?.value <= testForValue
        default:
          console.error(
            `operator ${operator} not supported, checking condition failed!`
          )
          return false
      }
    },
  },
}
